import { Subject } from 'rxjs';
import { IAlert } from "../Interfaces/Alert.interfaces";
import { message } from 'antd';

const subject = new Subject();

export const AlertService = {
    sendAlert: (messages: IAlert[]) => {
        messages.forEach(alert => {
            message[alert.type || 'success'](alert.text);
        });
    },
    clearAlert: () => subject.next([]),
    getAlert: () => subject.asObservable(),
};  